// extracted by mini-css-extract-plugin
module.exports = {"recommend-list":"recommend-list--3d7rV"};